import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import { rescueHtml } from '../Components/Tools.js';

const Page1Accueil_Operations = (props) => {
    const blue = '#069BD3';
    const purple = '#6571FE';
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/5;

    return (
        <div style={{width: '100%', height: '100%', padding: 0, background: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', position: 'relative', overflow: 'hidden'}}>
            
            {/* Décoration arrière-plan */}
            <div style={{position: 'absolute', top: '50%', right: -50, transform: 'translateY(-50%)', width: 300, height: 300, background: `rgba(${parseInt(blue.slice(1,3), 16)}, ${parseInt(blue.slice(3,5), 16)}, ${parseInt(blue.slice(5,7), 16)}, 0.08)`, borderRadius: '50%'}}></div>
            <div style={{position: 'absolute', bottom: -100, left: -100, width: 400, height: 400, background: `rgba(${parseInt(purple.slice(1,3), 16)}, ${parseInt(purple.slice(3,5), 16)}, ${parseInt(purple.slice(5,7), 16)}, 0.05)`, borderRadius: '50%'}}></div>

            {/* Header avec logo */}
            <div style={{padding: '20px 10px', display: 'flex', justifyContent: 'left', alignItems: 'center', zIndex: 1}}>
                {props.logo && (
                    <img style={{objectFit: 'contain', height: 200, maxWidth: '30%', borderRadius: 8}} src={props.logo} alt="Logo" />
                )}
            </div>

            {/* Contenu principal */}
            <div style={{flex: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', zIndex: 1}}>
                <p style={{fontSize: fontsize+20, margin: '0 0 20px 0'}}>
                    {rescueHtml(props.user.nom_organisme)}
                </p>
                <p style={{fontSize: fontsize+8, color: '#666', margin: '0 0 20px 0', fontWeight: 300}}>
                    {rescueHtml(props.user.nom_budget)}
                </p>
                <div style={{height: 3, width: 80, background: blue, margin: '0 auto 30px auto', borderRadius: 2}}></div>
                <p style={{fontSize: fontsize+14, color: blue}}>
                    Reporting Détaillé des Opérations
                </p>
            </div>

            {/* Spacer pour pousser le footer en bas */}
            <div style={{flex: 1}}></div>

            {/* Footer */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666', margin: 0}}>
                        {props.date}
                    </p>
                </div>
                <div style={{fontSize: fontsize, color: '#999', textAlign: 'right'}}>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page1Accueil_Operations;
